// React imports
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Material-UI
import { makeStyles } from 'tss-react/mui';

// React-Bootstrap
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button';

// Images
import studyIcon from '../assets/images/Icons_Study_Small.png';
import { AiOutlineFolder } from 'react-icons/ai';

// Banner types: info, warning
const useStyles = makeStyles()({
  info: {
    color: 'white',
    backgroundColor: '#003E65',
    backgroundImage: 'linear-gradient(to right, #003E65 50%, #0c89d7)',
    padding: '24px 30px 28px 20px',
    width: 'auto',
    maxWidth: '1900px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.06)',
    fontSize: '15px'
  },
  warning: {
    color: 'black',
    backgroundColor: '#FFAF13',
    backgroundImage: 'linear-gradient(to right, #ffed42, #FFAF13 90%)',
    padding: '24px 30px 28px 20px',
    width: 'auto',
    maxWidth: '1900px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.06)',
    fontSize: '15px'
  },
  banner: {
    width: '100%', 
    padding: '40px'
  },
  actionCol: {
    minWidth: '120px',
    margin: 'auto',
    width: '50%',
    textAlign: 'center'
  },
  imageCol: {
    minWidth: '120px'
  },
  image: {
    width: '80px', 
    maxHeight: '100%', 
    margin: '0 15px'
  },
  title: {
    marginLeft: 0,
    paddingLeft: 0
  }
});

export function Banner({type='info', title='Banner Title', message='Body Text', actionButton, image, ...props}) {
  const { classes } = useStyles();
  let location = useLocation();

  const [wrapperColor, setWrapperColor] = useState('rgba(0,0,0,0)');

  useEffect(() => {
    if (location?.pathname === '/home') {
      setWrapperColor('#001B2C');
    } else {
      setWrapperColor('rgba(0,0,0,0)');
    }
  }, [location, wrapperColor])

  let imageCol = image ? (
    <Col xs={1} className={classes.imageCol}>
      <div>
        <img src={image} className={classes.image} alt='' />
      </div>
    </Col>
    ) : (<Col xs={1} />);

  let actionCol = actionButton ? (
    <Col className={classes.actionCol}>
      {actionButton}
    </Col>
    ) : (<></>);

  return (
    <div className={classes.banner} style={{ backgroundColor: wrapperColor }}>
      <Container className={classes[type]}>
        <Row>
          {imageCol}
          <Col xs={9}>
            <Row>
              <h4 className={classes.title}>{title}</h4>
            </Row>
            <Row>
              {message}
            </Row>
          </Col>
          {actionCol}
        </Row>
      </Container>
    </div>
  );
}

export default Banner;